/* eslint-disable no-nested-ternary */

import Cookies from 'js-cookie';

const isStrHU = (str) => str === 'hu';

class Culture {
    /** Returns culture code hu|en */
    static get() {
        return document.documentElement.lang;
    }

    /** Returns true if culture is Hungarian */
    static getBool() {
        return document.documentElement.lang === 'hu';
    }

    static getDayStr(culture, day) {
        if (!isStrHU(culture)) {
            return typeof day === 'number' ? day > 1 ? `${day} days` : `${day} day` : 'day(s)';
        }
        return typeof day === 'number' ? `${day} nap` : 'nap';
    }

    static getDay(culture, day) {
        if (culture !== undefined && !culture) {
            return typeof day === 'number'
                ? day > 1
                    ? `${day} days`
                    : `${day} day`
                : 'day(s)';
        }
        return typeof day === 'number' ? `${day} nap` : 'nap';
    }
}

// performance tests below

const timingResults = new Map();
let timeoutId = null;

function batchLogTiming() {
    if (timeoutId) {
        clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
        timingResults.forEach((batchData, methodName) => {
            console.log(`${methodName}: ${batchData.time.toFixed(3)}ms (${batchData.count} calls batched)`);
        });
        timingResults.clear();
    }, 100); // 100ms delay to batch timings
}

function timeMethod(method, methodName) {
    // eslint-disable-next-line func-names
    return function (...args) {
        const start = performance.now();
        const result = method.apply(this, args);
        const duration = performance.now() - start;

        if (!timingResults.has(methodName)) {
            timingResults.set(methodName, { time: 0, count: 1 });
        }
        const batchData = timingResults.get(methodName);
        timingResults.set(methodName, { time: batchData.time + duration, count: batchData.count + 1 });

        batchLogTiming();

        return result;
    };
}

function wrapWithTiming(Class) {
    const classMethods = Object.getOwnPropertyNames(Class);

    classMethods.forEach((methodName) => {
        const originalMethod = Class[methodName] || Class.prototype[methodName];
        if (typeof originalMethod === 'function') {
            const timedMethod = timeMethod(originalMethod, `Culture.${methodName}`);
            if (Class[methodName]) {
                Class[methodName] = timedMethod;
            } else {
                Class.prototype[methodName] = timedMethod;
            }
        }
    });
}

// wrapWithTiming(Culture); // comment out to disable logging

export default Culture;
